<template>
  <div class="home">
    <Header />

    <div>
      <carousel :autoplay="true" :nav="false" :items="1" :loop="true">
        <div class="background-wrapper" v-for="(img, imgIndex) in imageCarousel" :key="imgIndex"
          :style="{ backgroundImage:  'url(' + img.image + ')'}">
          <h3 class="text-center"></h3>
          <div class="text-center mt-5"></div>
        </div>
      </carousel>
    </div>




    <!-- welcome message -->
    <div class="row mt-5 container-fluid">
      <div class="col-md-6 col-sm pl-5 order-2 message">
        <h4 class="text-left font-weight-bold">WELCOME TO JESUS THE SAVIOUR CATHOLIC CHURCH</h4>
        <p class="text-left mt-5">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quia
          reiciendis error obcaecati
          unde odio quam molestiae assumenda minus, aliquid et ipsam cumque. Asperiores optio,
          distinctio aperiam perspiciatis quisquam nisi eos!</p>
        <div class="text-left">
          <!-- <button class="btn-view">View More</button> -->
        </div>

      </div>

      <div class="col-md-6 col-sm order-1 parish-priest">
        <img src="../assets/Images/Fr-Ozoh-bg.png" alt="church">
      </div>
    </div>

    <!-- welcome message -->


    <!-- Register -->
    <div id="membership">
      <div class="membership_wrapper">
        <div id="membership_wrapper-content" class="text-center">
          <h6 class="membership_wrapper-title">A Place where Christ reigns</h6>
          <h4 class="membership_wrapper-word">Join us in the holy sacrifice of the mass this Sunday.
          </h4>
          <button class="btn-jscc mt-5" @click="toggleRegisterMassModal">Register</button>
        </div>
      </div>
    </div>
    <!-- Register -->



    <!-- mission and vision -->
    <div class="church mt-5 container">
      <div class="church_section">

        <div class="church_card" v-for="(church, churchIndex) in churchEntity" :key="churchIndex">
          <div class="church_card-wrapper">
            <div class="church_card-div"
              :style="{ backgroundImage:  'url(' + church.background + ')'}"></div>
            <div class="church_card-body">
              <h4>{{church.title}}</h4>
              <p>{{church.body}}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- mission and vision -->


    <!-- events -->
    <div class="scripture">
      <div class="scripture_wrapper">
        <div class="scripture_wrapper-body">
          <h4 class="text-white pt-5"><strong>SIRACH 1:23</strong></h4>
          <p class="text-white text-left">Wait and be patient, and later you will be glad you did.</p>
        </div>

        <!-- <div class="event_wrapper-button">
          <button class="btn-jscc" @click="viewCalendar()">View Calendar</button>
        </div> -->

      </div>
    </div>
    <!-- events -->




    <!-- <div class="program-wrapper mb-5">

      <carousel :autoplay="true" :nav="false" :items="3" :autoWidth="true" :loop="true">

        <div class="item-wrapper">
          <div class="text-center mb-3">
            <h5 class="text-white">Audio Stream</h5>
          </div>

          <div class="row">
            <div class="col-md-6">
              <img src="../assets/icons/mixlr-logo.png" alt="mixlr-logo" width="100" height="100">
            </div>

            <div class="col-md-6">
              <p class="text-white">Stream us live on mixlr</p>
            </div>
          </div>
          <div class="text-center">
            <button class="btn-view btn-sm">Listen</button>
          </div>

        </div>

        <div class="item-wrapper p-4">
          <div class="text-center mb-3">
            <h5 class="text-white">Youtube Channel</h5>
          </div>


          <div class="">
            <div>
              <iframe width="450" height="200"
                src="https://www.youtube.com/embed/rxtGDlC4o2U"></iframe>
              <div class="text-center">
                <a href="https://www.youtube.com/channel/UChFCHCW8fi-ndB7INLUMatg" target="_blank"
                  class="btn-view btn-sm">Subscribe</a>
              </div>

            </div>
          </div>
        </div>

        <div class="item-wrapper">
          <div class="text-center mb-3">
            <h5 class="text-white">Building Project</h5>
          </div>

          <div class="row">
            <div class="col-md-6">
              <img src="../assets/icons/mixlr-logo.png" alt="mixlr-logo" width="100" height="100">
            </div>

            <div class="col-md-6">
              <p class="text-white">"Then Isaac sowed in that land, and reaped in the same year a
                hundredfold; and the Lord blessed him." <br> Genesis 26: 12</p>
            </div>
          </div>
          <div class="text-center">
            <button class="btn-view btn-sm">Donate</button>
          </div>
        </div>

        <div class="item-wrapper">
          <div class="text-center mb-3">
            <h5 class="text-white">2021 Calendar</h5>
          </div>

          <div class="row">
            <div class="col-md-6">
              <img src="../assets/icons/mixlr-logo.png" alt="mixlr-logo" width="100" height="100">
            </div>

            <div class="col-md-6">
              <p class="text-white">Don't miss out on any of our activities</p>
            </div>
          </div>
          <div class="text-center">
            <button class="btn-view btn-sm" @click="viewCalendar()">View Calendar</button>
          </div>
        </div>


      </carousel>
    </div>  -->

    <div class="container">
      <div class="row mt-5">
        <div class="col-md-6 col-sm">
          <iframe  width="560" height="315" src="https://www.youtube.com/embed/rxtGDlC4o2U" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>

        <div class="col-md-6 col-sm">
         <iframe width="560" height="315" src="https://www.youtube.com/embed/xRTnbcDfS3o" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>


      <div class="text-center mt-4">
        <a href="https://www.youtube.com/channel/UChFCHCW8fi-ndB7INLUMatg" target="_blank"
          class="btn-view btn-sm">Subscribe</a>
      </div>
    </div>

    <!-- events -->
    <div class="event">
      <div class="event_wrapper">

        <div class="event_wrapper-body">
          <h4>UPCOMING EVENTS</h4>
          <p>Be sure to visit our event page regularly for upcoming events</p>
        </div>

        <div class="event_wrapper-button">
          <button class="btn-jscc" @click="viewCalendar()">View Calendar</button>
        </div>

      </div>
    </div>
    <!-- events -->

    <div class="container mb-5 mt-3 pt-3">
      <h5 class="text-center">SOCIETIES</h5>

      <div>
        <carousel :autoplay="true" :nav="false" :loop="true" :responsive="{0:{items: 1}, 600:{items: 2 },  1000:{items: 4 }}">
          <div class="m-3" v-for="(society, societyIndex) in churchSociety" :key="societyIndex">
            <figure>
              <img :src=society.imgSrc :alt=society.alt width="200px" height="250px">
            </figure>
            <figcaption>{{society.name}}</figcaption>
          </div>
        </carousel>
      </div>

      <div class="text-center">
        <button class="btn-view" @click="navigate()">View More</button>
      </div>

    </div>



    <!-- <div class="container mb-5 mt-5">
      <h5 class="text-center">GALLERY</h5>
      <div class="d-flex">
        <div class="m-3" v-for="(society, societyIndex) in churchSociety" :key="societyIndex">
          <figure>
            <img :src=society.imgSrc :alt=society.alt width="250px" height="250px">
          </figure>
          <figcaption>{{society.name}}</figcaption>
        </div>

      </div>
      <div class="text-center">
        <button class="btn-view" @click="navigate()">View More</button>
      </div>

    </div>
 -->

    <RegisterForMass v-if="isRegisterMass" @close="toggleRegisterMassModal"></RegisterForMass>
    <Thanksgiving v-if="isThanksgiving"></Thanksgiving>

    <Footer />
    <BackUp />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/navigation/Header.vue';
import Footer from '@/components/navigation/Footer.vue';
import BackUp from '@/components/BackUp.vue';
import RegisterForMass from '@/components/forms/RegisterForMass.vue';
import Thanksgiving from '@/components/forms/Thanksgiving.vue';
import carousel from 'vue-owl-carousel'
import { societies } from '@/Data/society.js';
import axios from 'axios';
export default {
  data() {
    return {
      churchSociety: [],
      isRegisterMass: false,
      isThanksgiving: false,
      imageCarousel: [{
          textContent: 'A place',
          image: require('../assets/Images/ckc.jpg')
        },
        {
          textContent: 'A place',
          image: require('../assets/Images/ckccc.jpg')
        },
        {
          textContent: 'A place',
          image: require('../assets/Images/ckcc.jpg')
        },


      ],
      churchEntity: [{
          title: 'Our Vision',
          body: 'To be connected in christ; moved by the spirit Our Mission',
          background: require('../assets/Images/mission.jpg')
        },
        {
          title: 'Our Mission',
          body: 'To lead people into a growing relationship of Jesus Christ',
          background: require('../assets/Images/bible-mission.jpg')
        },
        {
          title: 'Core Values',
          body: 'To model the nature of God which is love and a culture of excellence while delivering selfless service.',
          background: require('../assets/Images/church.jpg')
        }
      ]
    }
  },

  components: {
    Header,
    Footer,
    carousel,
    BackUp,
    RegisterForMass,
    Thanksgiving
  },

  methods: {
    navigate() {
      this.$router.push({
        path: 'Societies'
      })
    },
    viewCalendar() {
      this.$router.push({
        path: 'Calendar'
      })
    },
    closeModal: function () {
      this.$emit('close');
    },
    toggleRegisterMassModal() {
      this.isRegisterMass = !this.isRegisterMass
    },
    toggleThanksgivingModal() {
      this.isThanksgiving = !this.isThanksgiving
    },
   async paymentCheck() {
     const searchParams = new URLSearchParams(window.location.search);
     const status = searchParams.get("status");
     const transactionId = Number(searchParams.get("transaction_id"));
     const transactionRef = searchParams.get("tx_ref");
    //  const { $toast  } = this;
     // console.log('Status', status);
     // console.log('transaction Id', transactionId);
     if (status !== null && transactionId !== null && transactionRef !== null) {

       const response = await axios.post('/payment/savePayment', JSON.stringify({ transactionId }));
       const data = await response;
      //  console.log(data);
       if (data.data.status) {
         this.$swal('Payment was successful!',
           'God bless you abundantly',
           'success');
            this.$router.push({
              path: '/'
            })
       }
     }
     }
    // closeModalWithEscape() {
    //   document.addEventListener("keydown", (e) => {
    //   if (this.isVisible == true && e.keyCode == 27) {
    //     this.toggleModal();
    //   }
    // });
    // },

  },
  created() {
    societies.map((element) => {
      this.churchSociety.push(element)
    })
  },
  mounted() {
    this.paymentCheck()
  }
};
</script>

<style scoped>

.background-wrapper {
  /* background: url('../assets/Images/jscc-church.jpg'); */
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 671px;
  position: relative;
  z-index: 1;
}

h3 {
  padding-top: 250px;
  color: #fff;
}

.btn-worship {
  background: #E00B80;
  color: #fff;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border: none;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  transition-duration: 0.4s;
}

.btn-worship:hover,
.btn-view:hover {
  background-color: #fff;
  /* Green */
  color: #0A2463;
  border: 1px solid #0A2463;
}

.btn-view {
  background: #0A2463;
  color: #fff;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border: none;
  padding: 10px 30px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  transition-duration: 0.4s;
}

.about {
  background: rgba(7, 3, 26, 0.75);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  height: 100px;
  color: #fff;
}

.program-wrapper {
  background: rgba(24, 19, 51, 0.75);
  color: #fff;
  height: 300px;

}

.about-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

ul li {
  margin: 0;
  padding: 0;
  line-height: 30px;
}

.item-wrapper {
  width: 500px;
  height: 330px;
  /* background: rgba(7, 3, 26, 0.75); */
}

.owl-carousel {
  background: #f8f9fa !important;
}

#membership {
  background: #000;
  background: #636363;
  background: -moz-linear-gradient(rgba(48, 48, 54, .8), rgba(44, 33, 36, .8)), url('../assets/Images/chalice.jpg');
  background: linear-gradient(rgba(48, 48, 54, .8), rgba(44, 33, 36, .8)), url('../assets/Images/chalice.jpg');
  background-position-x: 0%, 0%;
  background-position-y: 0%, 0%;
  background-repeat: repeat, repeat;
  background-attachment: scroll, scroll;
  background-size: auto, auto;
  height: 70%;
  background-attachment: fixed;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  padding: 1rem 0;

}

#membership_wrapper {
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  max-width: 960px;
  display: flex;
  height: 100%;
  -moz-box-align: center;
  align-items: center;

}

#membership_wrapper-content h6 {
  text-transform: uppercase;
  color: #f49642;
  font-size: 1.3rem;
  margin-bottom: 2.5rem;
}

#membership_wrapper-content h4 {
  color: #fff;
  font-weight: 500;
  font-size: 2rem;
  margin-bottom: 0.35em;
}

.church_section {
  margin: -16px;
  display: flex;
  flex-flow: row wrap;
  flex-direction: row;
  flex-wrap: wrap;
  box-sizing: border-box;
}


.church_card {
  padding: 16px;
  width: 100%;
  margin: 0;
  width: 360px;
}

.church_card-wrapper {
  margin: auto;
  box-shadow: none;
  border-radius: 10px;
  transition: 0.3s cubic-bezier(.47, 1.64, .41, .8);
  overflow: hidden;
  color: rgba(0, 0, 0, 0.87);
  background-color: #fff;
  max-height: 360px;
}

.church_card-div {
  width: 100%;
  height: 0px;
  padding-bottom: 56.25%;
  background-color: rgba(0, 0, 0, 0.08);
  /* background-image: url("../assets/Images/mission.jpg"); */
  display: block;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.church_card-body {
  padding: 24px;
  background-color: #fafafa;
}

/* .church_card-body:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  transform: scale(1.1);
} */

.church_card-body h4 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 0.4em;
  line-height: 2;
  letter-spacing: 0.00938em;
}

.church_card-body p {
  color: rgba(0, 0, 0, 0.72);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}

.event_wrapper {
  height: 250px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 6rem;
  background: linear-gradient(rgba(201, 135, 27, 0.5), rgba(201, 135, 27, 0.5)), url("../assets/Images/audience.jpg");
  background-position-x: 0%, 0%;
  background-position-y: 0%, 0%;
  background-repeat: repeat, repeat;
  background-attachment: scroll, scroll;
  background-size: auto, auto;
  margin-top: 4rem;
  text-align: left;
  align-items: center;
  background-size: cover;
  justify-content: space-between;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}

.event_wrapper-body h4 {
  font-size: 2.3rem;
  letter-spacing: 3px;
  color: #fff;
  margin: 0;
  font-weight: 700;
}

.event_wrapper-body p {
  font-size: 1.3rem;
  letter-spacing: 3px;
  color: #fff;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}


.scripture_wrapper-body {
   height: 250px;
  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap; */
  padding: 0 6rem;
  background: linear-gradient(rgba(48, 48, 54, .8), rgba(44, 33, 36, .8)), url("../assets/Images/prayer.jpg");
  background-position-x: 0%, 0%;
  background-position-y: 0%, 0%;
  background-repeat: repeat, repeat;
  background-attachment: scroll, scroll;
  background-size: auto, auto;
  margin-top: 4rem;
  text-align: left;
  align-items: center;
  background-size: cover;
  justify-content: space-between;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}

@media only screen and (min-width:320px) {
  .message {
    order: 1;
  }

  .parish-priest {
    order: 2;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .message {
    order: 1;
  }

  .parish-priest {
    order: 2;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .message {
    order: 1;
  }

  .parish-priest {
    order: 2;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .message {
    order: 2;
  }

  .parish-priest {
    order: 1;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .message {
    order: 2;
  }

  .parish-priest {
    order: 1;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .message {
    order: 2;
  }

  .parish-priest {
    order: 1;
  }
}



</style>
